import * as _ from 'lodash'
import * as Services from "../../../Services";
import * as Models from "../../../Models";
import * as toastr from "toastr";


export interface IBypassEventScope extends ng.IScope {
    bypassEventCtrl: BypassEventController;
}

export class BypassEventController {
    public static $inject = ['$state', '$scope', '$modalInstance','CustomerApiClient', 'availableBypassEvents'];
    public selectedOption: Models.SelectOption;

    constructor(
        public $state: angular.ui.IStateService,
        public $scope: IBypassEventScope,
        public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
        private customerApiClient: Services.CustomerApiClient.ICustomerApiClient,
        public availableBypassEvents: Models.SelectOption[],
        private igsCustomerNumber: string,
    ) {
        $scope.bypassEventCtrl = this;
        this.availableBypassEvents = availableBypassEvents
        this.igsCustomerNumber = this.$state.params["igsCustomerNumber"]
    }

    public submitBypass = () => {
        return
/*        this.customerApiClient
            .submitCustomerEventBypass(this.igsCustomerNumber, this.selectedOption.value)
            .then(() => {
                toastr.success(
                    "Success",
                    "The event was successfully bypassed.",
                );
                this.$modalInstance.close();
                this.$state.reload();
            })
            .catch(() => {
                toastr.error(
                    "Error",
                    "Something went wrong trying to process your request.",
                );
                this.$modalInstance.close();
            })
*/    }

    public closeModal = () => {
        this.$modalInstance.close();
    }
}
